// Variables
var apiReady = false;

// Custom event
var eventGoogleMapAPIReady = document.createEvent('Event');
eventGoogleMapAPIReady.initEvent('google-map-api-ready', true, false);

// Inject GoogleMap API script
function loadGoogleMapAPI(opts) {
    if (!apiReady) {
        var apiKey = "";
        if (typeof opts.apiKey === "string" && opts.apiKey !== "") {
            apiKey = "key=" + opts.apiKey + "&";
        }

        var tag = document.createElement('script');
        tag.src = "https://maps.googleapis.com/maps/api/js?" + apiKey + "callback=onGoogleMapAPIReady";
        tag.async = 'true';
        tag.defer = 'true';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}

// Trigger API ready event
window.onGoogleMapAPIReady = function () {
    apiReady = true;
    document.dispatchEvent(eventGoogleMapAPIReady);
};

// Export a function to 
module.exports = function (opts) {

    // Validate options
    if (opts === undefined) {
        opts = {};
    }
    if (typeof opts.onReady !== "function") {
        opts.onReady = function () { };
    }

    // Trigger load (executed only if not already loaded)
    loadGoogleMapAPI(opts);

    // API is NOT ready
    if (!apiReady) {
        document.addEventListener('google-map-api-ready', function () {
            // API ready, execute...
            opts.onReady();
        }, false);
        return;
    }

    // Default execution, presume the API is ready ...
    opts.onReady();

};


// WEBPACK FOOTER //
// ./Sig.Web/src/utils/google-map-api/index.js